import {Dropdown} from './dropdown';

export enum NumChildren {
  NONE,
  ONE,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
  TEN,
  ELEVEN,
  TWELVE,
}

const NUM_CHILDREN_OPTIONS_FR: Dropdown<NumChildren>[] = [
  {name: `Aucun enfant`, value: 0},
  {name: `1 enfant`, value: 1},
  {name: `2 enfants`, value: 2},
  {name: `3 enfants`, value: 3},
  {name: `4 enfants`, value: 4},
  {name: `5 enfants`, value: 5},
  {name: `6 enfants`, value: 6},
  {name: `7 enfants`, value: 7},
  {name: `8 enfants`, value: 8},
  {name: `9 enfants`, value: 9},
  {name: `10 enfants`, value: 10},
  {name: `11 enfants`, value: 11},
  {name: `12 enfants`, value: 12},
];

const NUM_CHILDREN_OPTIONS_EN: Dropdown<NumChildren>[] = [
  {name: `No children`, value: 0},
  {name: `1 child`, value: 1},
  {name: `2 children`, value: 2},
  {name: `3 children`, value: 3},
  {name: `4 children`, value: 4},
  {name: `5 children`, value: 5},
  {name: `6 children`, value: 6},
  {name: `7 children`, value: 7},
  {name: `8 children`, value: 8},
  {name: `9 children`, value: 9},
  {name: `10 children`, value: 10},
  {name: `11 children`, value: 11},
  {name: `12 children`, value: 12},
];

export const NUM_CHILDREN_OPTIONS = {
  en: NUM_CHILDREN_OPTIONS_EN,
  fr: NUM_CHILDREN_OPTIONS_FR,
};
